<template>
<div id="info">
  <v-app id="infoapp">
    <v-row justify="center">
      <v-dialog v-model="dialog" content-class="info-dialog">
        <v-card>
          <v-card-title>
            <span class="headline"  v-if="this.image">
              <img :src="this.image">
            </span>
            <span class="headline"  v-if="!this.image">
              {{ this.$store.mapZone }}
            </span>
            <v-btn text icon  color="primary" class="info-close-btn" @click="closeDialog">
            <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row > 
              <v-col  cols="12" class="pb-0 subtitle-1"><h4>{{$t('your_address')}}</h4></v-col>
            </v-row>
            <v-row >
               <v-col  cols="12"  class="cat-value">{{ this.$store.searchedAddressText }}</v-col>
            </v-row>
             <v-row >
                        <v-col  cols="12" class="minimap">
                          <img @click="closeDialog" :src=this.staticURL>
                          <div class="minipointer" @click="closeDialog">
                            <v-img  src="@/assets/images/marker.svg"  height="30" style="height: 30px; margin-left:-2px;margin-top:2px" contain></v-img>
                          </div>
                        <p class="calculator-disclaimer">En saisissant vos données, vous autorisez Groupe E Celsius à les utiliser afin de garantir une expérience utilisateur optimale.</p>
                        </v-col>
                      </v-row>
            <v-row v-if="this.disponibility == 'NOT'">
              <v-col cols="12"  sm="12">
               <span  v-html="this.title" v-if="this.title" class="p2"> <br></span>
                <p > {{$t('simulation_not_possible')}}.</p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="login" v-if="this.disponibility != 'NOT'">{{$t('simulate_connection')}}</v-btn>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="contact" v-if="this.disponibility == 'NOT'">{{$t('contact_celsius')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
export default {
  name: 'Info',
  data () {
    return {
      dialog: false,
      description: '',
      title: '',
      image: '',
      staticURL:'',
      disponibility: '',
    }
  },
  props: [ 'showLoginDialog','showContactDialog' ],
  computed: {
  },
  methods: {
    login(){
      console.log("login")
        this.showLoginDialog()
    },
    contact(){
      console.log("contact")
      this.showContactDialog()
    },
    back() {
      return true
    },
    openDialog(){
      this.description = ''
      this.disponibility = ''
      this.image = ''
      this.staticURL = 'https://api.mapbox.com/styles/v1/notil/ck7np2rrb0mg41imkry1w1o2o/static/'+this.$store.position[0]+','+this.$store.position[1]+',15/400x200?access_token=pk.eyJ1Ijoibm90aWwiLCJhIjoiY2p2MmhjenhkMTNibzN6a2N1cWRzZmYyciJ9.OJOYbGff0Z2qUSx5jCn5eQ'
      if (this.$store.mapZone){
        this.description = this.$store.mapZones[this.$store.mapZone].description
        this.title = this.$store.mapZones[this.$store.mapZone].name
        this.disponibility = this.$store.mapZones[this.$store.mapZone].disponibility
        if (this.$store.mapZones[this.$store.mapZone].image.length)
          this.image = this.$store.backendURL+this.$store.mapZones[this.$store.mapZone].image
      }else{
      this.title = ''
      this.description = ''
      this.disponibility = ''

      }
      if (this.disponibility == ''){
        this.disponibility = 'NOT'
        this.description = this.$t('no_disponibility')
      }
      this.dialog = true
    },
    closeDialog(){
      this.dialog = false
    }
  }

}
</script>

